<template>
  <BaseDataIterator :service="fetchData" disable-search>
    <template #default="dataIteratorProps">
      <BaseDataTable :data="dataIteratorProps.data">
        <template #header>
          <SmsCampaignListHeader />
        </template>

        <template #default="dataTableProps">
          <SmsCampaignListItem :sms-campaign="dataTableProps.item" />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { projectSmsCampaignsClient } from '@/api/clients';
import SmsCampaignListHeader from './SmsCampaignListHeader.vue';
import SmsCampaignListItem from './SmsCampaignListItem.vue';

export default {
  components: {
    SmsCampaignListHeader,
    SmsCampaignListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      default: null,
    },
  },
  methods: {
    fetchData() {
      return projectSmsCampaignsClient.list(this.projectId, {
        include: [
          'smsMessage',
          'phoneNumbersCount',
          'phoneNumbersSentCount',
          'phoneNumbersFailedCount',
        ],
      });
    },
  },
};
</script>
